(function () {
    'use strict';

    function commentsController($scope, $log, $timeout, $rootScope, $location,
        sessionData, newNotesData, thumbnailsData) {
        var vm = this;
        vm.sessionData = sessionData;
        vm.thumbnailsData = thumbnailsData;
        vm.newNotesData = newNotesData;

        vm.mode = 'New';
        vm.setMode = function (mode) {
            vm.mode = mode;
        }

        vm.newNotesData.forEach(function (x) {
            var thumbnailMatch = vm.thumbnailsData.find(function (t) {
                return (t.WorkflowId === x.Note.ObjectId)  && (t.Path === x.Note.Path);
            });
            if (thumbnailMatch && thumbnailMatch.Thumbnails.length > 0) {
                var prefix = thumbnailMatch.IsTemplate ? 'gettemplate' : 'getupload';
                x.Note.ThumbnailUrl = '/files/' + prefix + '?blobreference=' + thumbnailMatch.Thumbnails[0] + '&fileName='+ thumbnailMatch.Thumbnails[0];
            }
        });
    }

    commentsController.$inject = ['$scope', '$log', '$timeout', '$rootScope', '$location',
        'sessionData', 'newNotesData', 'thumbnailsData'];

    angular.module('ecap.dashboards').controller('commentsController', commentsController);
})();
